import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";

import Home from "../views/home/Home.vue";
import Attendance from "../views/attendance/Attendance.vue";
import Queue from "../views/queue/Queue.vue";
import Rating from "../views/rating/Rating.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/attendance/:id",
    name: "Attendance",
    component: Attendance,
  },
  {
    path: "/queue",
    name: "Queue",
    component: Queue,
  },
  {
    path: "/rating/:attendanceID/:deskID",
    name: "Rating",
    component: Rating,
  },
  {
    path: "*",
    redirect: "/home",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
